export function downloadCsv(csvData: string, filename = 'download.csv'): void {
  const content = new window.Blob([csvData], { type: 'text/csv' })
  const link = document.createElement('a')
  link.setAttribute('href', window.URL.createObjectURL(content))
  link.setAttribute('download', filename)
  document.body.appendChild(link) // Required for FF
  link.click()
  document.body.removeChild(link)
}
